import { get } from 'lodash';
import { modifyAlpha } from '../../../../utils/modifyColour';

export const styles = ({ color, margin, padding, typography }) => ({
  addBtn: {
    float: 'right',
    marginTop: 22,
  },
  checkIcon: {
    color: get(color, 'primaryButtonBackground'),
  },
  controlsContainer: {
    display: 'flex',
  },
  nameFieldContainer: {
    width: 320,
  },
  pageBodyClass: {
    paddingTop: 0,
  },
  pageFilterAndSortClass: {
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 0,
    paddingTop: 0,
  },
  tableRow: {
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: modifyAlpha(color.primaryButtonBackground, 0.2),
      "& > .MuiTableCell-root": {
        backgroundColor: 'transparent',
        verticalAlign: 'middle',
      },
    },
    "& > .MuiTableCell-root": {
      verticalAlign: 'middle',
    },
  },
  tooltipContainer: {
    backgroundColor: get(color, 'gray'),
    padding: get(padding, 'p5'),
    borderRadius: get(padding, 'p10'),
    marginLeft: get(margin, 'm4'),
  },
  tsTierName: {
    color: get(color, 'primaryButtonBackground'),
    fontFamily: get(typography, 'buttonText'),
  },
  typeFieldContainer: {
    marginLeft: 4,
    width: 320,
  },
  accessTypeFilterContainer: {
    marginLeft: 4,
    width: 320,
  },
  warningIcon: {
    color: get(color, 'warning'),
    marginLeft: get(margin, 'm10'),
    marginRight: get(margin, 'm4'),
    fontSize: 14,
    marginTop: get(margin, 'm4'),
  },
  expanderColumn: {
    color: get(color, 'primary'),
    marginLeft: get(margin, 'm10'),
    marginRight: get(margin, 'm4'),
    fontSize: 28,
    marginTop: get(margin, 'm4'),
    position: 'relative',
    top: '6px',
  },
  apiContainer: {
    minWidth: '98% !important',
    height: '98% !important',
    marginTop: '0',
    '& .MuiDialogTitle-root' : {
      paddingLeft: get(padding, 'p36'),
      paddingTop: get(padding, 'p36'),
    },
    '& .MuiDialogContent-root': {
      marginTop: '-40px',
      padding: '0',
    },
  },
  linkButton: {
    color: get(color, 'primaryButtonBackground'),
    cursor: 'pointer',
    fontWeight: '400',
    fontFamily: get(typography, 'buttonText'),
  },
  linkDisableButton: {
    color: get(color, 'darkGreyBackground'),
    cursor: 'none',
    fontWeight: '500',
    fontFamily: get(typography, 'buttonText'),
  },
  closeButton: {
    marginTop: '20px !important',
  },
  tierButton: {
    '&.Mui-disabled': {
      border: '0 !important',
      backgroundColor: 'transparent !important',
    },
    '&.MuiButton-text': {
      padding: 0,
      justifyContent: 'left',
    },
  },
  paperClass: {
    width: '65%',
    height: 610,
    maxWidth: 'none',
    '& button:focus': {
      outlineWidth: '1px !important',
      outlineOffset: '1px !important',
      outlineStyle: 'solid !important',
      outlineColor: get(color, 'primaryButtonBackground'),
    },
  },
});

export default styles;
